module.exports = __webpack_public_path__ + "assets/img/9_101_big.0528900c.jpg";